import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { WindowLocationService } from '~commonInfra/services/WindowLocationService';
import { UrlParamKeys } from '~commonInfra/url/UrlParamKeys';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { EnterPredictiveModelSubspaceReduxAction } from '~src/predictiveModel/actions/EnterPredictiveModelSubspaceAction';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { setOrderAction } from '~src/spacesPlatform/actions/SetOrderAction';
import { getOrderClausesFromQueryParam } from '~src/spacesPlatform/components/Explorer/ExplorerUrlBindings';
import {
  getDefaultOrderForPredictiveModelSubSpace
} from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

export function* handleEnterPredictiveModelSubspace(action: EnterPredictiveModelSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.predictiveModelDetailInfo,
      spaceType: 'predictiveModel',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
    const hashQuery: any = WindowLocationService.getHashQueryObject();
    const orderFromQuery = getOrderClausesFromQueryParam(
      hashQuery[UrlParamKeys.Order],
      getDefaultOrderForPredictiveModelSubSpace(spaceInfo)
    );
    yield put(setOrderAction(orderFromQuery));
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
